import api from "PFCore/api";
import { Id, Profile } from "PFTypes";

export const fetchProfile = async (profileId: Id): Promise<Profile> =>
  api<Profile>({
    url: `admin/profiles/${profileId}`
  });
